<template>
    <div class='home'>
      <div style='margin-bottom:5em; position: relative; display: table'>
        <img src='../assets/homePage/download.png' style='width:90%;'>
        <a class="download" href="https://sj.qq.com/myapp/detail.htm?apkName=com.voibook.voicebook" target="_blank">下载音书APP >></a>
      </div>
      <div class='container'>
        <div id='productAndService'>
          <div class='wordDiv'>
            <p class='subTitle'>产品与服务</p>
            <p class='subTitleEn'>Product and Service</p>
          </div>
          <div class='imgContainer'>
            <div id='productImg' v-for='(pro,index) in products' :key='index'>
              <div class='psa'>
                <img :src='pro.proPic' :alt='pro.picAlt' class='image'>
                <div class='overlay'>
                  <div class='text' v-for='over in pro.proOver' :key='over.overImg'>
                    <img :src='over.overImg'>
                    <span><router-link :to='over.overUrl'>{{over.overSpan}}</router-link></span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div id='desc'>
            <div class='descDiv' v-for='desc in descDivs' :key='desc.title'>
              <span class='descTitle'>{{desc.title}}</span><br>
              <span class='descDetail'>{{desc.detail}}</span>
            </div>
          </div>
        </div>
        <div id='ourTechnology'>
          <div class='wordDiv'>
            <p class='subTitle'>我们的技术</p>
            <p class='subTitleEn'>Our Technology</p>
          </div>
          <div class='imgContainer'>
            <div id='technology1'>
              <div class='tech'>
                <div id='imageTech1'>
                  <div class='techDetail'>
                    <img src='../assets/homePage/technology1-1.png'><br>
                    <span>语音技术</span>
                  </div>
                </div>
                <div class='overlay'>
                  <div class='textTech'>
                    <img src='../assets/homePage/technology1-1.png'><br>
                    <span>语音技术</span>
                    <div class='textTechDetail' style='line-height:1.5; margin-top:0.8em'>
                      <span>成熟的语音识别技术</span><br>
                      <span>支持音书APP随意切换翻译距离</span><br>
                      <span>翻译准确率高达95%</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div id='technology2'>
              <div class='tech'>
                <div id='imageTech2'>
                  <div class='techDetail'>
                    <img src='../assets/homePage/technology2-1.png'><br>
                    <span>图像技术</span>
                  </div>
                </div>
                <div class='overlay'>
                  <div class='textTech'>
                    <img src='../assets/homePage/technology2-1.png'><br>
                    <span>图像技术</span>
                    <div class='textTechDetail' style='line-height:1.5; margin-top:0.8em'>
                      <span>采用人脸检测和关键点识别</span><br>
                      <span>等图像算法实现动态视频贴纸</span><br>
                      <span>构建和谐的手语交流空间</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div id='technology3'>
              <div class='tech'>
                <div id='imageTech3'>
                  <div class='techDetail'>
                    <img src='../assets/homePage/technology3-1.png'><br>
                    <span>智能硬件</span>
                  </div>
                </div>
                <div class='overlay'>
                  <div class='textTech'>
                    <img src='../assets/homePage/technology3-1.png'><br>
                    <span>智能硬件</span>
                    <div class='textTechDetail' style='line-height:1.5; margin-top:0.8em'>
                      <span>智能语音翻译配套硬件</span><br>
                      <span>让无障碍沟通更加顺畅</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 关于我们 -->
        <div id='aboutUs'>
          <div id='aboutDiv'>
            <div class='wordDiv' id='aboutText'>
              <p class='subTitle'>关于我们</p>
              <p class='subTitleEn'>About Us</p>
              <p id='voiDesc' class="about-us-p">广州音书科技有限公司是一家国家级高新技术企业，致力于通过互联网+人工智能技术改善听力言语障碍群体的沟通现状，并打造听力言语障碍群体的服务平台。目前已对外提供数亿次辅助沟通服务。</p>
              <p class="about-us-p">音书科技通过为学校、政务服务中心、医院、银行、博物馆、图书馆等公共服务机构提供无障碍沟通解决方案，帮助听障人士更好地融入社会生活。同时，音书科技还上线了音书APP，为百万听障用户搭建起服务平台，并研发音书手表等产品帮助他们更高效地与外界交流。</p>
              <p class="about-us-p">截止到目前，音书科技已经服务了超过100家公共服务机构和100万听障用户，音书已经成为听障人士与外界对话的重要纽带。</p>
            </div>
            <div id='joinUs'>
              <div style='text-align:left;line-height:1.3;padding: 0em 2em; opacity:1;' @click="openUrl('https://www.zhipin.com/gongsir/4bf2213be61e308d1nd509u_EQ~~.html?ka=company-jobs')">
                <span>加入我们</span><br>
                <span>Join Us</span><br>
                <span>￣￣￣￣</span>
              </div>
              <div id='pic' style='opacity:1'>
                <img src='../assets/homePage/kexuejishu--2_2x.png'>
                <img src='../assets/homePage/kexuejishu-_2x.png'>
                <img src='../assets/homePage/shuju_2x.png'>
              </div>
              <span style='font-size:3em;opacity:1;'>···</span>
              <span style='text-align:center;opacity:1;' @click="openUrl('https://www.zhipin.com/gongsir/4bf2213be61e308d1nd509u_EQ~~.html?ka=company-jobs')">了解更多 > </span>
            </div>
          </div>
          <div class='imgContainer'>
            <div id='about' v-for='person in persons' :key='person.name'>
              <img :src='person.pic'><br>
              <span>{{person.name}}</span>
              <span style='color:rgb(164,164,164);font-size:16px;position:relative;top:12px;'>{{person.pos}}</span>
            </div>
          </div>
          <div class="know-more-box">
            <span id='knowMore'><router-link to='/aboutUs/none' style='text-decoration:none;'>了解更多</router-link></span>
            <span id='joinSpan'><router-link to='/joinUs' style='text-decoration:none;'>加入我们</router-link></span>
          </div>
        </div>
        <div id='news' style='text-align:left;'>
          <div class='wordDiv'>
            <p class='subTitle'>新闻动态</p>
            <p class='subTitleEn'>News</p>
          </div>
          <div id='newsLine' v-for='news in recentNews' :key='news.newsTitle'>
            <el-row :gutter='20'>
              <el-col :span='4'><img :src='news.pic' alt='recentNews'></el-col>
              <el-col :span='1'></el-col>
              <el-col :span='17'>
                <div @click="openUrl(news.src)">
                  <span class='newsTitle'>{{news.newsTitle}}</span><br>
                  <span class='newsDetail'>{{news.newsDetail}}</span>
                </div>
              </el-col>
              <el-col :span='1'></el-col>
              <el-col :span='2'><img style="cursor: pointer;" @click="openUrl(news.src)" src='../assets/homePage/arrow-right2.png'></el-col>
            </el-row>
          </div><br><br>
          <span id='knowMore'><router-link to='./news' style='text-decoration:none;'>了解更多</router-link></span>
        </div>
      </div>
      <myFooter></myFooter>
      <customer-service />
    </div>
</template>

<script>
import news from '@/lib/news-list.js'
import bus from '@/lib/bus.js'
import CustomerService from '@/components/CustomerService.vue'

export default {
  name: 'HomePage',
  components: {
    CustomerService
  },
  data () {
    return {
      products: [
        {
          proPic: require('../assets/homePage/product1.png'),
          picAlt: '字幕服务',
          proOver: [
            {
              overImg: require('../assets/homePage/phone-white.png'),
              overSpan: '个人字幕服务',
              overUrl: '/product/personal/personal'
            },
            {
              overImg: require('../assets/homePage/pc-white.png'),
              overSpan: '机构字幕服务',
              overUrl: '/product/institution/institution'
            }
          ]
        },
        {
          proPic: require('../assets/homePage/product2.png'),
          picAlt: '言语康复服务',
          proOver: [
            {
              overImg: require('../assets/homePage/icon2.png'),
              overSpan: '智能言语评测',
              overUrl: '/product/speech/restore'
            },
            {
              overImg: require('../assets/homePage/icon(3).png'),
              overSpan: '言语训练',
              overUrl: '/product/speech/train'
            }
          ]
        },
        {
          proPic: require('../assets/homePage/product3.png'),
          picAlt: '手语服务',
          proOver: [
            {
              overImg: require('../assets/homePage/icon.png'),
              overSpan: '手语翻译',
              overUrl: '/product/service/translate'
            },
            {
              overImg: require('../assets/homePage/icon(1).png'),
              overSpan: '手语培训',
              overUrl: '/product/service/signTrain'
            },
            {
              overImg: require('../assets/homePage/icon(2).png'),
              overSpan: '影视文化传播',
              overUrl: '/product/service/video'
            }
          ]
        }
      ],
      descDivs: [
        {
          title: '字幕服务',
          detail: '音书APP以及字幕系统为听障群体和机构提供多场景下的语音文字翻译服务'
        },
        {
          title: '言语康复服务',
          detail: 'AI+言语康复，提高听力言语障碍群体的普通话发音水平'
        },
        {
          title: '手语服务',
          detail: '为听障及机构提供多种手语服务，打造全方位无障碍沟通环境'
        }
      ],
      persons: [
        {
          pic: require('../assets/about/zfg.jpg'),
          name: '曾凡钢',
          pos: '首席顾问'
        },
        {
          pic: require('../assets/about/scc.png'),
          name: '石城川',
          pos: 'CEO'
        },
        {
          pic: require('../assets/about/cgq.png'),
          name: '陈国强',
          pos: '技术合伙人'
        },
        {
          pic: require('../assets/about/wfy.png'),
          name: '王飞扬',
          pos: '市场合伙人'
        },
        {
          pic: require('../assets/about/psq.png'),
          name: '彭驷庆',
          pos: '产品合伙人'
        }
      ],
      recentNews: news.slice(0, 5)
    }
  },
  methods: {
      openUrl (url) {
          window.open(url, '_blank')
      }
  },
  mounted () {
    bus.$emit('changeSelectedIndex', 0)
  }
}
</script>

<style scoped>
@import './homePage.css';
</style>



// WEBPACK FOOTER //
// src/pages/HomePage.vue